var _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMore({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "15px",
    height: "24px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    x: "0px",
    y: "0px",
    width: "15px",
    height: "24px",
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAYCAQAAACPDG/iAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAHdElNRQfoAhQSLgsQDwddAAAAjklEQVQoz32S2xXCIBAFRxvQErYkO8AO7CCtpARLoARLun7EYLIP4IPHzAF2F4Ss9WeXidiRtY5QLvB67/NM4PO4qRaQzQQ0FbahFPa9QvjfkwrHdybCOc4g+Dw54UpolzFLDr+PRXOHB+gC8/CUlggPSc3gKEkOfwWtoGAGBetSQ4FsE1r+FYVsXVrxkb9NoGSM5ehRMwAAAABJRU5ErkJggg=="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.537b4dd073fd863947a7d5711c23409d.svg";
export { ForwardRef as ReactComponent };